import { Injectable } from '@angular/core';
// import { environment } from '../../environments/environment';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CasiStoryType, IProjectFromWeb } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { SettingsService } from '../settings/settings.service';
import { LoggerService } from '../shared/logger.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiUserStoryTypesService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<CasiStoryType[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${this.settings.apiUrl}/userstorytype`))
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => new CasiStoryType(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserStoryTypesService extends CasiUserStoryTypesService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http, settingService);
  }

  get(): Observable<any> {
    this.loading = true;
    return this.apiService.getHttpCall('userstorytype', 'get')
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => new CasiStoryType(x))),
        tap(() => (this.loading = false)),
        catchError(errRes => {
          return throwError(() => errRes)
        })
      )
    // .subscribe({
    //   next: resData => resolve(resData),
    //   error: err => reject(err)
    // });
    //   })
    // return new Promise((resolve, reject) => {

  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`userstorytype/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('userstorytype', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`userstorytype/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`userstorytype/${id}`, 'destroy');
  }

}
